/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSkillsCreate } from "../../funcs/llmSkillsCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateSkillRequest$inboundSchema,
};

export const tool$llmSkillsCreate: ToolDefinition<typeof args> = {
  name: "llm-skills-create",
  description: `Create skill

Create a new skill by uploading files. The uploaded files must include a SKILL.md manifest. Accepts multipart form data with individual files or a single zip archive.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSkillsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
